import { Box, DialogContent, Typography } from '@mui/material';
import { t } from 'i18next';
import AddAccountProgressBar from '../shared/AddAccountProgressBar';
import AccountDetailsForm from './AccountDetailsForm';
import ModalFooter from '../shared/ModalFooter';
import ModalSectionTitle from '../shared/ModalSectionTitle';
import { StepsForManual } from '../useAddAccountNavigation';
import { ClassificationItem } from '../categories.utility';
import { AccountDetailsFormState } from './useAccountDetailsForm';
import { Classification } from '@/store/classificationsApi';

interface ManualAddAccountDetailsProps {
  handleOnCancel: () => void;
  footerLabels: any;
  updateModalStep: (step: StepsForManual) => void;
  selectedClassification: ClassificationItem;
  accountDetailsForm: AccountDetailsFormState;
  updateAccountDetailForm: (state: AccountDetailsFormState) => void;
  classifications: Classification[];
}

const ManualAddAccountDetails = ({
  handleOnCancel,
  footerLabels,
  updateModalStep,
  selectedClassification,
  accountDetailsForm,
  updateAccountDetailForm,
  classifications,
}: ManualAddAccountDetailsProps) => {
  return (
    <>
      <DialogContent>
        <Box sx={{ marginBottom: 4 }}>
          <AddAccountProgressBar
            activeStep={StepsForManual.MANUAL_ACCOUNT_DETAILS}
          />
          <ModalSectionTitle>
            {t('addAccountModal.accountDetails.title')}
          </ModalSectionTitle>
          <Typography sx={{ fontWeight: 600, fontSize: '0.875rem' }}>
            {selectedClassification.Name}
          </Typography>
        </Box>

        <AccountDetailsForm
          initialValues={accountDetailsForm.values}
          onFormChange={updateAccountDetailForm}
          selectedClassification={selectedClassification}
          classifications={classifications}
        />
      </DialogContent>

      <ModalFooter
        onCancel={handleOnCancel}
        onBack={() => {
          handleOnCancel();
          updateModalStep(StepsForManual.MANUAL_ACCOUNT_TYPE);
        }}
        label={{ ...footerLabels, primaryCta: footerLabels.continue }}
        onPrimaryAction={() =>
          updateModalStep(StepsForManual.MANUAL_PORTFOLIO_DIVERSIFICATION)
        }
        isPrimaryActionDisabled={!accountDetailsForm?.isValid}
      />
    </>
  );
};

export default ManualAddAccountDetails;
